var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456.7 421.4l-94.1-94.1c22.7-30.2 34.9-66.9 34.8-104.6C397.4 126.4 319 48 222.7 48 126.4 48 48 126.4 48 222.7c0 96.3 78.4 174.7 174.7 174.7 37.7 0 74.4-12.2 104.6-34.8l94.1 94.1c10.3 9.2 26.1 8.3 35.3-2 8.5-9.5 8.5-23.8 0-33.3zM97.9 222.7c0-68.9 55.9-124.8 124.8-124.8s124.8 55.9 124.8 124.8-55.9 124.8-124.8 124.8c-68.9-.1-124.7-55.9-124.8-124.8z"
  })));
}

export default SvgSearch;